import { onUpdate } from "../../../function/onUpdate";
import { getPO, updatePO } from "./query";

export default async function onUpdatePO({ values, client }) {
  let statusCode = values.statusCode;
  if (values.openQty === 0) {
    statusCode = "900";
  }
  if (statusCode === "400") {
    values = { ...values, openQty: 0 };
  }
  const fieldsToUpdate = [
    { field: "customerID", createUpdate: true },
    // { field: "vendorID", createUpdate: true },

    { field: "date", createUpdate: false },
    { field: "number", createUpdate: false },
    { field: "priceCur", createUpdate: true },
    { field: "price", createUpdate: true },
    { field: "CRD", createUpdate: true },
    { field: "qty", createUpdate: true },
    { field: "openQty", createUpdate: true },
    { field: "billingStatus", createUpdate: false },
    { field: "materialEntityRelationID", createUpdate: false },
    { field: "statusCode", createUpdate: false },
  ];

  await onUpdate({
    type: "PO",
    values: { ...values, statusCode },
    mutation: updatePO,
    query: getPO,
    getInitialValue: null,
    fieldsToUpdate,
    client,
    refetchQueries: [],
    onUpdate: null,
  });
}
